var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ButtonText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-family: Red Hat Text, sans-serif;\n\tfont-style: normal;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tcolor: ", ";\n\t", "\n"], ["\n\tfont-family: Red Hat Text, sans-serif;\n\tfont-style: normal;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tcolor: ", ";\n\t", "\n"])), function (props) { return (props.color ? props.color : 'inherit'); }, function (props) {
    switch (props.size) {
        case 'small':
            return 'font-size: 0.75rem;line-height: 133%;';
        case 'medium':
            return 'font-size: 0.875rem;line-height: 129%;';
        case 'large':
            return 'font-size: 1rem;line-height: 113%;';
        default:
            return 'font-size: 0.875rem;line-height: 129%;';
    }
});
var templateObject_1;
